import isServerSide from '@helpers/misc/isServerSide'
import authURL from '@providers/url'

import saveJWT from './saveJWT'

export default async function refreshJWT() {
  if (isServerSide()) return

  if (!localStorage?.getItem('justo_jwt_refresh')) return

  const response = await fetch(`${authURL}/auth/refreshToken`, {
    method: 'POST',
    headers: {
      'X-ORION-REFRESH': localStorage?.getItem('justo_jwt_refresh') || null
    }
  })

  const result = await response.json()

  if (result.error || !result.token) {
    console.log('Error refreshing JWT. Will reset Session')
    saveJWT({})
    return
  }

  saveJWT({token: result.token})
}
